"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconMrw = void 0;
var React = __importStar(require("react"));
var IconMrw = function (props) { return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "Delivery/ic_mrw" },
            React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 }),
            React.createElement("g", { id: "MRW", transform: "translate(2.000000, 2.000000)" },
                React.createElement("rect", { id: "Background", fill: "#212B4E", x: 0, y: 0, width: 20, height: 20, rx: 1.66666667 }),
                React.createElement("path", { d: "M13.8854334,9 L13.6945271,10.1138254 L13.6037953,10.5149266 L13.9188705,10.0070962 L14.3436541,9.38409462 C14.534606,9.10668842 14.7446258,9 15.1121603,9 L16,9 L13.8329285,12 L12,12 L12.4535222,9 L13.8854334,9 Z M18.5,9 L16.281166,12 L14.5,12 L14.5712505,11.2745514 L16.1946927,9.13230016 L16.052143,10.0070962 L15.924962,10.5746737 L16.2302936,10.1138254 L16.7595416,9.38409462 C16.9630798,9.10668842 17.1870448,9 17.5788984,9 L18.5,9 Z", id: "W", fill: "#DF4E47" }),
                React.createElement("path", { d: "M9.61210157,10.3997145 L9.99218503,10.3997145 C10.2797276,10.3997145 10.3966728,10.3271615 10.3966728,10.1393964 C10.3966728,10.0028548 10.2991952,9.95163132 10.0360569,9.95163132 L9.68517484,9.95163132 L9.61210157,10.3997145 Z M9.95809348,11.3427814 L9.45612809,11.3427814 L9.34891671,12 L7.76994728,12 L8.25244509,9 L10.6647479,9 C11.590622,9 12,9.29017129 12,9.94310767 C12,10.4466558 11.8002012,10.7795269 11.4054472,10.9971452 L11.8391363,12 L10.18225,12 L9.95809348,11.3427814 Z M3.53020734,12 L2,12 L2.48245124,9 L4.5974776,9 L4.88986382,10.2887847 L5.37715867,9.40538336 C5.53313214,9.11949429 5.75239852,9 6.11795115,9 L7.71634159,9 L7.23393692,12 L5.703683,12 L5.93272975,10.7368271 L5.99606923,10.4466558 L5.76702249,10.8477977 L5.06041469,12 L4.12476015,12 L3.82748375,10.8477977 L3.73978651,10.450938 L3.71053857,10.7368271 L3.53020734,12 L3.53020734,12 Z", id: "MR", fill: "#FFFFFF" })))))); };
exports.IconMrw = IconMrw;
exports.IconMrw.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconMrw;
